import {React, useEffect} from 'react';
import {parisSportsImage} from '../../assets';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as YellowPageAfterSVG } from '../../assets/SVG/YellowPageAfter.svg';
import { yellow1, yellow2, yellow3, yellow4 } from '../../assets';

const yellowImageMap = {
  './images/puzzles/yellow/yellow1.png': yellow1,
  './images/puzzles/yellow/yellow2.png': yellow2,
  './images/puzzles/yellow/yellow3.png': yellow3,
  './images/puzzles/yellow/yellow4.png': yellow4
};
const YellowPageAfter = ({ feedback, onNext, isTrue, wrongImage, correctImage }) => {
  const navigate = useNavigate();
    useEffect(() => {
      const homeWiseathlete = document.getElementById('home_wiseathlete');
      const correctBoxYellow = document.getElementById('correct-box-yellow');
      const tryAgainBoxYellow = document.getElementById('Try-again-box-yellow');
      const photoBoxYellow = document.getElementById('photo-box-yellow');
      const tryAgainBoxYellowtext = document.getElementById('Try-again-box-yellow-text');
      const correctBoxYellowtext = document.getElementById('correct-box-yellow-text');
      if (homeWiseathlete && correctBoxYellow && tryAgainBoxYellow && photoBoxYellow)
      {  
        homeWiseathlete.addEventListener('mouseover', () => {
            homeWiseathlete.style.cursor = 'pointer';
        });
  
        homeWiseathlete.addEventListener('mouseout', () => {
            homeWiseathlete.style.cursor = 'default';
        });
  
        homeWiseathlete.addEventListener('click', () => {
          navigate('/');
        });

  
        correctBoxYellow.addEventListener('mouseover', () => {
            correctBoxYellow.style.cursor = 'pointer';
        });
  
        correctBoxYellow.addEventListener('mouseout', () => {
            correctBoxYellow.style.cursor = 'default';
        });
        correctBoxYellow.addEventListener('click', onNext);
        
  
        tryAgainBoxYellow.addEventListener('mouseover', () => {
            tryAgainBoxYellow.style.cursor = 'pointer';
        });
  
        tryAgainBoxYellow.addEventListener('mouseout', () => {
            tryAgainBoxYellow.style.cursor = 'default';
        });
        tryAgainBoxYellow.addEventListener('click',onNext);
        

        if(isTrue)
          {
            photoBoxYellow.setAttribute('href',yellowImageMap[correctImage]);
          }
          else
          {
            photoBoxYellow.setAttribute('href',yellowImageMap[wrongImage]);
          }


        if(isTrue) {
          tryAgainBoxYellow.style.display = "none";
            correctBoxYellowtext.textContent = "Next";
            
        }
        else {
          correctBoxYellow.style.display = "none";
          tryAgainBoxYellowtext.textContent = "Try Again";
        }
      }
     
    },[]);
  return (
    <div className="App-header-AfterYellow">
      <YellowPageAfterSVG/>
      <div className="question-discription-yellow-div">
          <p className="question-discription-yellow">{feedback}</p>
      </div>
    </div>
  );
}

export default YellowPageAfter;